export default __webpack_public_path__ + "static/210512_更新完成_jp-a41e1c91b4c298c997a7822472f20626.png";